import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUsers = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.167 19.5v-1.667a3.333 3.333 0 00-3.334-3.333H6.167a3.333 3.333 0 00-3.334 3.333V19.5M9.5 11.167a3.333 3.333 0 100-6.667 3.333 3.333 0 000 6.667zM21.167 19.5v-1.667a3.334 3.334 0 00-2.5-3.225M15.333 4.608a3.333 3.333 0 010 6.459",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export { SvgUsers as ReactComponent };
